<script>
    import { onMount } from "svelte";
    import LoadingTela from "./LoadingTela.svelte";
    let isLoading=false;
    let estados = [];
    let cidades = [];
    let estadoSelecionado = "";
    export let nomeEstadoSelecionado = "";
    export let cidadeSelecionada = "";
    export let nomeCidadeSelecionada = "";

    // Função para obter os estados
    async function getEstados() {
        isLoading=true;
        const response = await fetch(
            "https://servicodados.ibge.gov.br/api/v1/localidades/estados",
        );
        isLoading=false;
        return await response.json();
    }

    // Função para obter as cidades de um estado específico
    async function getCidades(estadoId) {
         isLoading=true;
        const response = await fetch(
            `https://servicodados.ibge.gov.br/api/v1/localidades/estados/${estadoId}/municipios`,
        );
         isLoading=false;
        return await response.json();
    }

    // Função para tratar a mudança de estado
    async function handleEstadoChange(event) {
        const estadoId = event.target.value;
        const estado = estados.find((e) => e.id == estadoId);
        estadoSelecionado = estadoId;
        nomeEstadoSelecionado = estado.nome;
        cidades = await getCidades(estadoId);
        cidadeSelecionada = "";
        nomeCidadeSelecionada = "";
    }

    // Função para tratar a mudança de cidade
    function handleCidadeChange(event) {
        const cidadeId = event.target.value;
        const cidade = cidades.find((c) => c.id == cidadeId);
        cidadeSelecionada = cidadeId;
        nomeCidadeSelecionada = cidade.nome;
    }

    onMount(async () => {
        estados = await getEstados();
    });
</script>
<style>
  


  label {
    display: flex;
    flex-direction: column;
    gap: 0.5rem;
    font-family: "Roboto", sans-serif;
    font-size: 1rem;
    color: #333;
  }







  select {
    font-family: "Roboto", sans-serif;
    font-size: 1rem;
    padding: 0.5rem;
    border: 1px solid #ccc;
    border-radius: 4px;
    outline: none;
    transition:
      border-color 0.3s,
      box-shadow 0.3s;
  }

  select {
    border-color: #1976d2;
    box-shadow: 0 0 0 3px rgba(25, 118, 210, 0.2);
  }

 
  select {
    
  }

  


</style>
<LoadingTela {isLoading} />
<div>
    <label>
        Selecione seu Estado:
        <select on:change={handleEstadoChange}>
            <option value="">Selecione seu Estado</option>
            {#each estados as estado}
                <option value={estado.id}>{estado.nome} </option>
            {/each}
        </select>
    </label>
    {#if nomeEstadoSelecionado}
    <label>
        Selecione sua Cidade:
        <select on:change={handleCidadeChange} disabled={cidades.length === 0}>
            <option value="">Selecione sua Cidade</option>
            {#each cidades as cidade}
                <option value={cidade.id}>{cidade.nome}</option>
            {/each}
        </select>
    </label>
    {/if}
</div>
